
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.8 25.85"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M19.79 25.85H0a12.32 12.32 0 012.38-7.29 9.74 9.74 0 013.39-2.93 8.68 8.68 0 018.05-.13c4.12 1.96 6.18 6.73 5.97 10.35zM16.52 6.48A6.46 6.46 0 1110.12 0a6.44 6.44 0 016.4 6.48z","fill":"#c6d4dc","data-name":"Layer 1"}})])])
          )
        }
      }
    